var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTraining(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.1663C12.4183 15.1663 16 12.1816 16 8.49967C16 4.81777 12.4183 1.83301 8 1.83301C3.58172 1.83301 0 4.81777 0 8.49967C0 12.1816 3.58172 15.1663 8 15.1663Z",
    fill: "#9DE5F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.923779 14.1695C1.54199 13.7259 1.98179 13.2042 2.26503 12.4521L3.81223 13.7709C3.09709 14.5292 2.23542 15.0259 1.20831 15.1636C1.03846 15.186 0.864679 15.0927 0.770519 14.9074C0.641421 14.6533 0.709973 14.323 0.923779 14.1695Z",
    fill: "#9DE5F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03347 8.04247C8.4736 8.4802 8.46347 8.78553 8.46347 9.31493C8.46347 9.50833 8.36167 9.73227 7.86287 9.73227C7.44547 9.73227 7.303 9.5796 7.303 9.05027C7.303 8.17487 7.6898 7.75747 7.985 7.503C8.32093 7.21793 8.891 6.90237 8.891 6.35272C8.891 5.88447 8.4838 5.6605 7.9748 5.6605C6.93647 5.6605 7.16047 6.44431 6.61075 6.44431C6.33591 6.44431 6 6.26109 6 5.86406C6 5.31437 6.63109 4.5 8.00533 4.5C9.30833 4.5 10.1735 5.22272 10.1735 6.17959C10.1735 7.1365 9.30833 7.82867 9.03347 8.04247ZM8.65687 11.2185C8.65687 11.6358 8.31073 12.0022 7.87307 12.0022C7.43533 12.0022 7.0994 11.6358 7.0994 11.2185C7.0994 10.7909 7.44553 10.4347 7.87307 10.4347C8.3006 10.4346 8.65687 10.7909 8.65687 11.2185Z",
    fill: "#2FA7CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraining);
export default __webpack_public_path__ + "static/media/training.24dd4fd009e3a2914039f13837cc6405.svg";
export { ForwardRef as ReactComponent };